import Tabs from "@/components/Tabs";
import { Path, useNavigate } from "@/router";
import { Outlet, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { FacilityDetailsHeader } from "../_components/FacilityDetailsHeader";
import AppLayout from "@/layouts/AppLayout";
import PageTitle from "@/components/PageTitle";
import { useFacilityNavLinks } from "../_utils";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import Breadcrumb from "@/components/Breadcrumb";

export default function FacilityDetailsLayout() {
  const { facilityId } = useParams();
  const { isCompactLayout: isMobile } = useIsCompactLayout();

  const location = useLocation();
  const { pathname } = location;
  const currentUrl = pathname.replace(/\/$/, "");
  const navigate = useNavigate();
  const navLinks = useFacilityNavLinks(facilityId);

  if (!facilityId) return null;

  const tabItems = [
    {
      label: "Contact",
      to: "/facilities/:facilityId/details/contact" as Path,
      active: currentUrl === `/facilities/${facilityId}/details/contact`
    },
    {
      label: "Notes and Tasks",
      to: "/facilities/:facilityId/details/notes" as Path,
      active: currentUrl === `/facilities/${facilityId}/details/notes`
    }
  ].map(({ label, to, active }) => ({
    label,
    onClick: () => navigate(to, { params: { facilityId } }),
    active
  }));

  const renderDesktopLayout = () => (
    <>
      <PageTitle pattern={location.pathname} title={"Facilities | Facility Details"} />
      <FacilityDetailsHeader facilityId={facilityId} />
      <Tabs tabItems={tabItems} />
      <div className="flex flex-col min-w-0" data-testid="tab-content">
        <Outlet />
      </div>
    </>
  );

  const renderMobileLayout = () => (
    <>
      <Breadcrumb
        compactOnly
        compactTitle="Facility Details"
        backLink={{
          to: "/facilities/:facilityId",
          params: { facilityId: facilityId! }
        }}
      />
      <PageTitle pattern={location.pathname} title={"Facilities | Facility Details"} />
      <FacilityDetailsHeader facilityId={facilityId} />
      <Tabs tabItems={tabItems} />
      <div className="flex flex-col min-w-0" data-testid="tab-content">
        <Outlet />
      </div>
    </>
  );

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      {isMobile ? renderMobileLayout() : renderDesktopLayout()}
    </AppLayout>
  );
}
